import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CapitalizePipe } from './capitalize/capitalize.pipe';
import { ThousandsPipe } from './thousandsPipe/thousandsPipe.pipe';
import { CensureEmailPipe } from './censure/censureEmailPipe.pipe';
import { CensureCellPipe } from './censure/censureCellPipe.pipe';


@NgModule({
  declarations: [
    CapitalizePipe,
    ThousandsPipe,
    CensureEmailPipe,
    CensureCellPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    CapitalizePipe,
    ThousandsPipe,
    CensureEmailPipe,
    CensureCellPipe
  ]
})
export class PipesModule { }
